import { useState, useEffect } from "react";
import { ActionHandlerFunction } from "@preveil-api";
import {
  Account, useAppSelector, DriveUIActionTypes, EntryItem, CollectionEntity, Feature, DriveFeature, NodePermissionType, COLLECTION_PROTOCOL_VERSIONS, DriveEntryType,
  PreveilDownloads, isUploadInProgress
} from "src/common";
import { CollapseWrapper, ShareDetails } from "..";
import { PeopleWithAccess } from "../entry-actions/directories/share";
import { UploadingAlert, V1ChildAlert } from "./side-panel-alerts";
import { selectIsPreveilDownloadsRoot } from "src/store";
import { RootState } from "src/store/configureStore";

type AllProps = {
  current_account: Account;
  entry: EntryItem;
  action?: string;
  collection_info: CollectionEntity;
  handleAction: ActionHandlerFunction;
}

function FolderDetailsComponent(props: AllProps) {
  const { current_account, entry, action, collection_info, handleAction } = props;
  const upload_folder_ids = useAppSelector((state: RootState) => state.ui.upload_folder_ids);
  const under_downloads = useAppSelector(selectIsPreveilDownloadsRoot) || entry.name === PreveilDownloads;
  const uploading_in_progress = isUploadInProgress(entry, upload_folder_ids);
  const [share_disabled, setSharedDisabled] = useState<boolean>(isShareDisabled());
  useEffect(() => {
    !!collection_info &&
      setSharedDisabled(isShareDisabled());
  }, [collection_info]);

  // Description: get the shared enabling status from regular permissions, directory name (exclude PreveilDownloads) and uploading_in_progress
  function isShareDisabled(): boolean {
    // NOTE: Disable if the folder is PreveilDownloads OR if it is a child of it
    return Feature.hidden(DriveFeature.Share, collection_info.permissions) || uploading_in_progress || under_downloads;
  }

  // Description: Filter conditions to show the V1 collection Directory Alert
  function showV1DirectoryAlert(): boolean {
    return collection_info.collection_protocol_version === COLLECTION_PROTOCOL_VERSIONS.V1 && entry.type === DriveEntryType.DIR &&
      !under_downloads && collection_info.permissions.type === NodePermissionType.edit_and_share;
  }

  return <>
    {/* Share Component - default opened */}
    {
      <CollapseWrapper
        handleAction={handleAction}
        hidden={share_disabled}
        title="Shared Details"
        open={action === DriveUIActionTypes.Share || action === DriveUIActionTypes.Details}>
        <ShareDetails
          current_account={current_account}
          entry={entry}
          collection_info={collection_info}
          action={action}
          handleAction={handleAction} />
      </CollapseWrapper>
    }
    {
      share_disabled &&
      <>
        {
          // NOTE: This section is for displaying people with access Read Only mode (edit permissions for recipients)
          (collection_info.permissions.type === NodePermissionType.edit && collection_info.shared_with.length > 0) &&
          <CollapseWrapper
            handleAction={handleAction}
            title={`People with Access (${collection_info.shared_with.length})`}
            className="pb-0"
            open={action === DriveUIActionTypes.Share || action === DriveUIActionTypes.Details}>
            <PeopleWithAccess shared_with={collection_info.shared_with} />
          </CollapseWrapper>
        }
        {
          showV1DirectoryAlert() && <V1ChildAlert />
        }
      </>
    }
    {
      uploading_in_progress && <UploadingAlert />
    }
  </>;
}

export default FolderDetailsComponent;
